<template lang="pug">
.register-row.form-label
  .register-group
    .register-key
      span.key-name 施設での食事
      span.validation-label 必須
    .register-value
      InputOutingNeedsMealTable(v-model="_items" :fields="fields")
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

import { NeedsMeal, OutingType } from "@/commons/services/Outings";
import InputOutingNeedsMealTable, { InputOutingNeedsMealTableItem, InputOutingNeedsMealTableField } from "@/pc/components/outings/InputOutingNeedsMealTable.vue";
import { OutingSettingGetModel } from "@/commons/services/OutingSettings";

/**
 * ### 外出外泊届け詳細 食事キャンセル入力コンポーネント
 */
@Component({
  components: {
    InputOutingNeedsMealTable
  }
})
export default class InputOutingNeedsMeal extends Vue {
  /** 1行あたりの情報配列 */
  @Prop({ required: true })
  value!: InputOutingNeedsMealModel;

  /** 外出外泊届け設定 */
  @Prop()
  setting!: OutingSettingGetModel;

  /** 列名配列 */
  fields: Array<InputOutingNeedsMealTableField> = [];

  get _items(): Array<InputOutingNeedsMealTableItem> {
    if (!this.value) {
      return [];
    }
    const items: Array<InputOutingNeedsMealTableItem> = [];
    items.push({
      datetime: this.value.startDatetime,
      needsMeal: this.value.startDateNeedsMeal
    });
    if (this.value.type == OutingType.STAYING_OUT) {
      items.push({
        datetime: this.value.endDatetime,
        needsMeal: this.value.endDateNeedsMeal as NeedsMeal
      });
    }
    return items;
  }

  /**
   * ### vue lifecycle mounted
   */
  public async mounted(): Promise<void> {
    const fields: Array<InputOutingNeedsMealTableField> = this.createFields();
    this.fields = fields;
    return;
  }

  /**
   * ### テーブル列名を作成する
   */
  public createFields(): Array<InputOutingNeedsMealTableField> {
    if (!this.setting) {
      return [];
    }

    const fields: Array<InputOutingNeedsMealTableField> = [];
    fields.push({ key: "date", label: "日", sortable: false, sortDirection: "desc", class: "date text-center" });

    // 食事列は設定に応じて表示／非表示を切り替える
    if (this.setting.useNeedsMeal.breakfast) {
      fields.push({ key: "breakfast", label: "朝食", sortable: false, sortDirection: "desc", class: "meal-name breakfast text-center" });
    }
    if (this.setting.useNeedsMeal.lunch) {
      fields.push({ key: "lunch", label: "昼食", sortable: false, sortDirection: "desc", class: "meal-name lunch text-center" });
    }
    if (this.setting.useNeedsMeal.snack) {
      fields.push({ key: "snack", label: "おやつ", sortable: false, sortDirection: "desc", class: "meal-name snack text-center" });
    }
    if (this.setting.useNeedsMeal.dinner) {
      fields.push({ key: "dinner", label: "夕食", sortable: false, sortDirection: "desc", class: "meal-name dinner text-center" });
    }
    return fields;
  }
}

export interface InputOutingNeedsMealModel {
  /** 外出外泊種別 */
  type: OutingType;
  /** 開始日時 */
  startDatetime: number;
  /** 開始日時の食事情報 */
  startDateNeedsMeal: NeedsMeal;
  /** 終了日時 */
  endDatetime: number;
  /** 終了日時の食事情報 */
  endDateNeedsMeal: NeedsMeal;
}
</script>
